import React from 'react';

import { ProcessSectionLayout } from '@/layouts/pages/business';
import { ProcessFeature } from '@/views/business';

const ProcessSection = () => (
  <ProcessSectionLayout>
    <ProcessFeature
      index="01"
      title="요청"
      description="3DAY"
      iconUrl="/pages/business/viral/sections/process/icon_1.png"
      contents={[`수량/제공내역확정`, `체험단 섭외`, `섭외 인원 선별`, `블랙리스트 체크`]}
    />
    <ProcessFeature
      index="02"
      title="기획"
      description="2DAY"
      iconUrl="/pages/business/viral/sections/process/icon_2.png"
      contents={[`진행인원 확정`, `가이드 제작`, `이벤트 제작(별도)`, `기타 진행준비`]}
    />
    <ProcessFeature
      index="03"
      title="진행"
      description="7DAY"
      iconUrl="/pages/business/viral/sections/process/icon_3.png"
      contents={[
        `체험단 체험 진행`,
        `가이드 배포`,
        `진행 현황 관리`,
        `원고 컨펌`,
        `데일리 게재 보고`,
      ]}
    />
    <ProcessFeature
      index="04"
      title="완료"
      description="1~2DAY"
      iconUrl="/pages/business/viral/sections/process/icon_4.png"
      contents={[`노출 현황 체크`, `최종 게재 보고`]}
    />
  </ProcessSectionLayout>
);

export default ProcessSection;
